import { httpClient } from 'utils/httpClient';
import {
  CalcularPromocionPayload, PromocionManualPayload, EstadoPromocionResponse,
} from 'types/promocion.types';

export const promocionService = {
  async calcular(payload: CalcularPromocionPayload): Promise<EstadoPromocionResponse[]> {
    return httpClient.post<EstadoPromocionResponse[]>('/promocion/calcular', payload);
  },
  async registrarManual(payload: PromocionManualPayload): Promise<EstadoPromocionResponse> {
    return httpClient.put<EstadoPromocionResponse>('/promocion/manual', payload);
  },
  async getOrdenMerito(params: { gradoId: number; seccionId: number; anioEscolarId: number }): Promise<EstadoPromocionResponse[]> {
    const q = new URLSearchParams({
      gradoId: String(params.gradoId),
      seccionId: String(params.seccionId),
      anioEscolarId: String(params.anioEscolarId),
    });
    return httpClient.get<EstadoPromocionResponse[]>(`/promocion/orden-merito?${q}`);
  },
  async listarPorAnio(anioEscolarId: number): Promise<EstadoPromocionResponse[]> {
    try {
      return await httpClient.get<EstadoPromocionResponse[]>(`/promocion?anioEscolarId=${anioEscolarId}`);
    } catch { return []; }
  },
};
